import ReducerCreator from '../registerReducer';
import { buildStoreItem, copyStoreItem } from '../storeItemBuilder';
import * as DIGITALCORRESPONDANCETABLES from './digitalCorrespondanceTables.constants';
import { DigitalCorrespondanceTable } from '@models/index';
import { StoreItem } from '../Store';
import { APPLICATION_DISCONNECTED } from '../constants.index';

const r = new ReducerCreator<DigitalCorrespondanceTable>()
    .register<DigitalCorrespondanceTable[]>(DIGITALCORRESPONDANCETABLES.DIGITAL_CORRESPONDANCE_TABLES_LOAD, (state, payload) => {
        const res = copyStoreItem(state.dictionary);
        res.isLoading = true;
        res.isLoaded = false;
        return res;
    })
    .register<DigitalCorrespondanceTable[]>(DIGITALCORRESPONDANCETABLES.DIGITAL_CORRESPONDANCE_TABLES_LOAD_SUCCESS, (state, payload) => {
        return buildStoreItem(payload);
    })
    .register<DigitalCorrespondanceTable[]>(DIGITALCORRESPONDANCETABLES.DIGITAL_CORRESPONDANCE_TABLE_ADD, (state, payload) => {
        const result = (Object as any).assign({}, state, { isLoading: true });
        return result;
    })
    .register<DigitalCorrespondanceTable>(DIGITALCORRESPONDANCETABLES.DIGITAL_CORRESPONDANCE_TABLE_ADD_SUCCESS, (state, payload) => {
        const result = copyStoreItem(state.dictionary);
        result.dictionary[payload.guid] = payload;
        result.isLoading = false;
        result.isLoaded = true;
        return result;
    })
    .register<any>(DIGITALCORRESPONDANCETABLES.DIGITAL_CORRESPONDANCE_TABLE_ADD_ERROR, (state, payload) => {
        const result = (Object as any).assign({}, state, { isLoading: false, isLoaded: true, hasError: true, errorMessage: payload.reason });
        return result;
    })
    .register<DigitalCorrespondanceTable[]>(DIGITALCORRESPONDANCETABLES.DIGITAL_CORRESPONDANCE_TABLE_UPDATE, (state, payload) => {
        const result = (Object as any).assign({}, state, { isLoading: true });
        return result;
    })
    .register<DigitalCorrespondanceTable>(DIGITALCORRESPONDANCETABLES.DIGITAL_CORRESPONDANCE_TABLE_UPDATE_SUCCESS, (state, payload) => {
        const result = copyStoreItem(state.dictionary);
        result.dictionary[payload.guid] = payload;
        result.isLoading = false;
        result.isLoaded = true;
        return result;
    })
    .register<any>(DIGITALCORRESPONDANCETABLES.DIGITAL_CORRESPONDANCE_TABLE_UPDATE_ERROR, (state, payload) => {
        const result = (Object as any).assign({}, state, { isLoading: false, isLoaded: true, hasError: true, errorMessage: payload.reason });
        return result;
    })
    .register<void>(DIGITALCORRESPONDANCETABLES.DIGITAL_CORRESPONDANCE_TABLE_DELETE, (state, payload) => {
        const result = (Object as any).assign({}, state, { isLoading: true });
        return result;
    })
    .register<string>(DIGITALCORRESPONDANCETABLES.DIGITAL_CORRESPONDANCE_TABLE_DELETE_SUCCESS, (state, payload) => {
        const result = copyStoreItem(state.dictionary);
        delete (result.dictionary[payload]);
        result.isLoaded = true;
        result.isLoading = false;
        return result;
    })
    .register<DigitalCorrespondanceTable>(APPLICATION_DISCONNECTED, (state, payload) => {
        return new StoreItem<DigitalCorrespondanceTable>();
    });

export function digitalCorrespondanceTablesReducer(state: StoreItem<DigitalCorrespondanceTable> = new StoreItem<DigitalCorrespondanceTable>(), action: { type: string, payload: any }) {
    return r.reduce(state, action);
}
